import deviation from "../deviation";

export default function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-array/src/threshold/scott.js
// module id = ../../../../d3-array/src/threshold/scott.js
// module chunks = 3